/*
 * Drop Down filter
 *
 * When a user selects a new category from the drop down menu, the current URL
 * is replaced with what is inside the value attribute of the selected <option>
 *
 *
 * Usage: 1. add 'data-dropdown-filter' to a <select> tag
 *        2. make sure the value of the <option> tag is a url
 *
 * Currently this is applied only on the mobile view. But this functionality can be used irrespective of the window size.
 * */

export default function handleDropdownSelect(dropdownFilters) {
    return (function () {
        const listenToSelectChange = () => {
            dropdownFilters.forEach(dropdownFilter =>
                dropdownFilter.addEventListener('change', function () {
                    window.location = this.value;
                })
            );
        };
        return {
            init: listenToSelectChange,
        };
    })().init();
}
